import { t } from 'i18next'

import AdInfo from './elements/AdInfo'
import { schemaBannerVideo } from './schemaBannerVideo'
import { schemaSponsoredBrand } from './schemaSponsoredBrand'

const schemaBanner: SchemaMediaReviewItems = {
  /**
   * Dados do anúncio
   */
  title: {
    title: t('rm:adReview.list.title'),
    // Row.tsx calls `render(infoRow)` as a plain function call, not JSX —
    // wrapping AdInfo in an element here gives it its own fiber, so its
    // internal useState isn't attributed to Row's memoized fiber (which
    // would otherwise make Row's hook count vary with the row count).
    render: data => <AdInfo key={data.id} {...data} />,
    showTotal: true
  }
}

export const schemas: Partial<Record<CampaignAdType, SchemaMediaReviewItems>> =
  {
    sponsored_brand: schemaSponsoredBrand,
    sponsored_brand_video: schemaSponsoredBrand,
    banner: schemaBanner,
    banner_video: schemaBannerVideo,
    banner_off_site: schemaBanner
  }
